// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".periodicity[data-v-66e578ba]{margin-top:-3px}", ""]);
// Exports
module.exports = exports;
